var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isHide)?_c('div',{class:[_vm._.proxy, ("proxy_" + (_vm.normalizedItem.componentType))],style:(Object.assign({}, {'--margin-top': _vm.$transformPx(_vm.normalizedItem.theme.marginTop || 0),
    '--margin-left': _vm.$transformPx(_vm.normalizedItem.theme.marginBoth || 0),
    '--margin-right': _vm.$transformPx(_vm.normalizedItem.theme.marginBoth || 0),
    '--padding-top': _vm.$transformPx(_vm.normalizedItem.theme.paddingTop || 0),
    '--padding-right': _vm.$transformPx(_vm.normalizedItem.theme.paddingRight || 0),
    '--padding-bottom': _vm.$transformPx(_vm.normalizedItem.theme.paddingBottom || 0),
    '--padding-left': _vm.$transformPx(_vm.normalizedItem.theme.paddingLeft || 0),
    '--border-radius': _vm.$transformPx(
      _vm.normalizedItem.theme.borderStyle === 'circle' ? 8 : 0
    ),
    '--color': _vm.normalizedItem.theme.fontColor || 'black'},
    (_vm.normalizedItem.theme.backgroundType && _vm.normalizedItem.theme.background
      ? _vm.normalizedItem.theme.backgroundType === 'color'
        ? {
            backgroundColor: _vm.normalizedItem.theme.background,
          }
        : {
            backgroundImage: ("url(" + (_vm.normalizedItem.theme.background) + ")"),
          }
      : _vm.undefind),
    {'--leftBackground': ("url(" + (_vm.normalizedItem.theme.leftBackground) + ")"),
    '--rightBackground': ("url(" + (_vm.normalizedItem.theme.rightBackground) + ")")}))},[_c(_vm.sourceComponent,_vm._b({tag:"component",on:{"hide":function($event){_vm.isHide = true}}},'component',_vm.normalizedItem,false),[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }